import Debug from "debug";

import languagesJson from "../../../../JetSmart.Web/languages.json";

interface Language {
	locale: string;
	country: string;
	lang: string;
	name: string;
}

export const LANGUAGES: { [key: string]: Language } = Object.assign(
	{},
	...languagesJson.Languages.Items.map((item: any) => {
		const key = item.key;
		delete item.key;
		return { [key]: item };
	})
);

const pathNameItems = window.location.pathname.split("/");
const countryFromPath = pathNameItems[1].toLowerCase();
const langFromPath = pathNameItems[2] ? pathNameItems[2].toLowerCase() : "es";
export const LANG = langFromPath + "-" + countryFromPath;
export const LANG_KEY = LANG.replace("-", "");
export const LANG_PATH = countryFromPath + "/" + langFromPath;
export const LANGUAGE = LANGUAGES[LANG_KEY];
export const LOCALE = LANGUAGE ? LANGUAGE.locale : LANGUAGES.escl.locale;

export const DEBUGIMPL = Debug;
